import { useEffect } from 'react';

import { useNavigate, useParams, useSelector } from 'third-party';

import { loginUrl } from 'constants/url';

import { useApp } from 'modules/app';

import { appSelectors } from 'selectors';

import { isUserAuthenticated } from 'utils/auth';

export const useAuth = () => {
  const isUserLogged = isUserAuthenticated();
  const { organizationId } = useParams();
  const isAppLoaded = useSelector(appSelectors.isAppLoaded);
  const selectedOrganizationId = useSelector(appSelectors.organizationId);
  const userId = useSelector(appSelectors.userId);

  const navigate = useNavigate();

  const { userInfo, refreshTokens, setAppIsLoaded, userLogOut } = useApp();

  useEffect(() => {
    if (!isUserLogged) {
      userLogOut();
      setAppIsLoaded(true);
      navigate(loginUrl());
      return;
    }

    if (isAppLoaded) {
      return;
    }

    if (!userId) {
      userInfo().then(it => {
        if (it.error) {
          navigate(loginUrl());
          return;
        }

        // Refresh tokens after fetching user info
        refreshTokens();
      });
      // Wait for userInfo to resolve; this effect re-runs once userId is set in Redux
      return;
    }

    if (organizationId && organizationId != selectedOrganizationId) {
      return;
    }

    setAppIsLoaded(true);
  }, [
    isAppLoaded,
    userId,
    isUserLogged,
    navigate,
    organizationId,
    selectedOrganizationId,
    refreshTokens,
    setAppIsLoaded,
    userInfo,
    userLogOut,
  ]);
};
